import Rgpd from './main'
import '../scss/index.scss'

document.addEventListener('app:load', init)

function init ()
{
	if (typeof app_rgpd === 'undefined' || !app_rgpd.services || !app_rgpd.services.length)
	{
		return
	}
	
	const rgpd = new Rgpd()
	
	rgpd.init()
}
